<div class="img-fluid">
  <div class="container-fluid splash" id="splash">
    <div class="container">
      <img src="/assets/img/4.jpg" alt="Portrait of Alpana" class="profile-image">
      <h1> <span class="title">Alpana Patel</span></h1>
      <h1 class="intro-text"><span class="lead">I'm a Software Developer|YouTuber|Digital Creater </span></h1>
      <div class="row">
        <div class="col-md-4 col-sm-6 col-xs-12 Center">
          <ul class="social-icons">
            <li>
              <a href="https://www.linkedin.com/in/alpnap/" class="linkedin"><i class="fa fa-linkedin "></i></a>
            </li>
            <li>
              <a href="https://www.instagram.com/the_alp_darpan/" class="dribbble"><i class="fa fa-instagram"></i>
              </a>
            </li>
            <li>
              <a href="https://twitter.com/alpna_p" class="twitter"><i class="fa fa-twitter"></i></a>
            </li>

            <li>
              <a href="https://github.com/alpnaP" class="github"><i class="fa fa-github"></i></a>
            </li>
            <li>
              <a href="https://www.youtube.com/@CodeWithAlpana" class="youtube"><i class="fa fa-youtube-square"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
<app-about></app-about>
<app-gallery></app-gallery>
<app-contact></app-contact>
